import { render } from "./Package-list.vue?vue&type=template&id=17535587&scoped=true"
import script from "./Package-list.vue?vue&type=script&lang=js"
export * from "./Package-list.vue?vue&type=script&lang=js"

import "./Package-list.vue?vue&type=style&index=0&id=17535587&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17535587"]])

export default __exports__